<template>
  <ComboPicker
    :label="label"
    strings="tag de veículo;a"
    icon="mdi-label"
    :orientation="orientation"
    :value="value"
    @input="(v) => $emit('input', v)"
    :whenEmpty="orientation == 'horizontal' ? 'Qualquer tag' : '(Qualquer)'"
    types="single-tag"
    :tags="allItems"
    :items="[]"
  />
</template>

<script>
import ComboPicker from 'oderon-vue/cpts/pickers/ComboPicker'
import { OrgApi } from '@/models'
import { orderBy } from 'oderon-commons/src/utils'

export default {
  components: {
    ComboPicker
  },
  props: {
    label: { type: String, default: 'Tag de veículo' },
    orientation: { type: String, default: 'vertical' },
    value: {},
    orgId: { type: Number, required: true }
  },
  watch: {
    // se a org mudar, zera a seleção, pois o valor anterior
    // não faz sentido para outra org.
    orgId() {
      this.fetchData()
      this.$emit('input', null)
    }
  },
  data() {
    return {
      allItems: []
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      let fetcher = new OrgApi(this.orgId)
      let rows = await fetcher.get('vehicles/tags')
      this.allItems = orderBy(rows, [['code', 'asc']])
    }
  }
}
</script>

<style></style>
